import { render, staticRenderFns } from "./releaseSalonDetail.vue?vue&type=template&id=b725a672&scoped=true&"
import script from "./releaseSalonDetail.vue?vue&type=script&lang=js&"
export * from "./releaseSalonDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseSalonDetail.vue?vue&type=style&index=0&id=b725a672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b725a672",
  null
  
)

export default component.exports